import { Stack } from '@mui/material';
import { type FC } from 'react';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export const JournalPageSkeleton: FC = () => {
    return (
        <Stack height="100%" alignItems="center" gap={2} sx={{ background: 'var(--tgui--secondary_bg_color)' }}>
            <Stack alignItems="center" justifyContent="center" minHeight="calc(var(--tg-viewport-content-safe-area-inset-top, 0px) + var(--tg-viewport-safe-area-inset-top, 0px))">
                <ThemedSkeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 1 }} />
            </Stack>

            <Stack gap={1} direction="column" width="90%" mb={1}>
                <ThemedSkeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 1 }} />
                <Stack gap={0.5} direction="row" justifyContent="space-between" width="100%">
                    {[1,2,3,4,5,6,7].map((i) => (
                        <ThemedSkeleton key={i} variant="rectangular" width={36} height={36} sx={{ borderRadius: 1 }} />
                    ))}
                </Stack>
            </Stack>

            <ThemedSkeleton variant="rectangular" width="90%" height={120} sx={{ borderRadius: 2 }} />
            <ThemedSkeleton variant="rectangular" width="90%" height={120} sx={{ borderRadius: 2 }} />
            <ThemedSkeleton variant="rectangular" width="90%" height={120} sx={{ borderRadius: 2 }} />
        </Stack>
    );
};

